import { LevelPlayMemory as Activity } from '.'

export const SLUG = 'memory'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'continue',
    waitValidation: true
  },
  Component: Activity
}
